import { BaSeParagraph, BaSeTheme } from '@base/react';
import styled from 'styled-components';
import backgroundBanner from '../../assets/background-banner.png';

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${BaSeTheme.colors.defaultColors.white};
`;

export const Content = styled.div`
  position: relative;
  background-color: ${BaSeTheme.colors.defaultColors.white};
  background-image: url(${backgroundBanner});
  background-repeat: repeat-x;
  height: 100%;
  width: 100%;
  min-height: calc(100vh - 61px);

  .BaSe--container {
    position: relative;
  }

  &::before {
    position: absolute;
    content: '';
    width: 100vw;
    height: 251px;
    display: block;
    top: 0;
    right: 0;

    background: radial-gradient(
      circle at top right,
      ${({ gradientColor }) => gradientColor} -10vw,
      transparent 40vw
    );
  }
`;

export const ContentOptions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  .BaSe--paragraph {
    color: ${BaSeTheme.colors.institucionais.cinzaSebrae45};
  }
`;

export const ContentActions = styled.div`
  margin-left: auto;
`;

export const Banner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  max-height: 251px;
  max-width: calc(${BaSeTheme.breakpoints.desktop.minWidth}px - (-8%));
  top: 0;
  left: -60px;

  background: url(${({ imageBannerManager }) => imageBannerManager}) no-repeat
    bottom 0 left;
`;

export const BoxHeader = styled.div`
  position: relative;
  display: inline-flex;
  width: 100%;
  margin-top: 57px;
  margin-bottom: 58px;
  justify-content: space-between;
  max-width: ${BaSeTheme.breakpoints.desktop.minWidth}px;
  max-height: 40px;
`;

export const BoxUserName = styled.div`
  padding-left: 20%;
  padding-right: 30px;
`;

export const ModalContent = styled.div`
  text-align: center;
  padding-top: 10px;
  padding-bottom: 16px;
`;

export const DataTableWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: ${BaSeTheme.breakpoints.desktop.minWidth}px;
  top: 0;
  padding-bottom: 145px;
`;

export const CustomFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ItemResultEntrevista = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;

export const CustomFilterWrapperAlign = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;

export const AlignFilds = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const WapperDataStatus = styled(BaSeParagraph)`
  font-size: 13.28px;
`;
